import { IStaticAccordion } from "../../../../../Contracts/StaticDataAccordion";
import { LegislationSections } from "../../../../Model/Enum/BEE123Enums";

export const WspAtr_MerSETA_Documents : Array<IStaticAccordion> = [
    {
      title: "ALL SETA's",
      groups: [
      ],
    },
    {
      title: "merSETA",
      groups: [
        {
          items: [
            {
              title: "Annualized reports",
              link:
                "Merseta Annual Report 2022_2023.pdf",
              section: LegislationSections.MerSETA_Documents
            },
            {
              title: "Sector skills plan",
              link:
                "",
              section: LegislationSections.MerSETA_Documents
            },
            {
              title: "Strategic plan",
              link:
                "",
              section: LegislationSections.MerSETA_Documents
            },
            {
              title: "National Skills Development Strategy III",
              link:
                "National Skills Development Strategy III.pdf",
              section: LegislationSections.MerSETA_Documents
            },
            {
              title: "National Skills Accord",
              link:
                "National Skills Accord.pdf",
              section: LegislationSections.MerSETA_Documents
            },            {
              title: "Authorization Page for Submission",
              link:
                "",
              section: LegislationSections.MerSETA_Documents
            }
          ],
        },
      ],
    }
  ];
  